import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { TagModule } from 'primeng/tag';
import { UpperCasePipe } from '@angular/common';
@Component({
  selector: 'app-env-tag',
  templateUrl: './env-tag.component.html',
  styles: [],
  imports: [TagModule, UpperCasePipe],
})
export class EnvTagComponent implements OnInit {
  env: string = environment.env;
  isProd: boolean = environment.production;
  constructor() {}

  ngOnInit(): void {}
}
